import React from 'react';
import { object } from 'prop-types';

import './sponsors-block.scss';

const SponsorsBlock = ({ sponsors, ...props }) => {
  return (
    sponsors && (
      <div className='sponsors__section'>
        {Object.keys(sponsors) && Object.keys(sponsors).length
          ? Object.keys(sponsors).map((sponsor, i) => (
              <div key={`${sponsor}-${i}`} className='sponsor'>
                <h2 className='sponsor__type'>{sponsor}</h2>
                <div className='sponsor__list'>
                  {sponsors[sponsor] && sponsors[sponsor].length
                    ? sponsors[sponsor].map((s) => (
                        <a
                          key={`${s.name}-${s.id}`}
                          href={s.url}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <img
                            src={s.logo}
                            alt={String(s.name).toUpperCase()}
                            title={String(s.name).toUpperCase()}
                            className='logo'
                          />
                        </a>
                      ))
                    : ''}
                </div>
              </div>
            ))
          : ''}
      </div>
    )
  );
};

SponsorsBlock.propTypes = {
  sponsors: object.isRequired,
};

export default SponsorsBlock;
